import {EntityService} from 'src/service/EntityService';

export class Oauth2GoogleService extends EntityService {

  static entity = 'iam-common/oauth2/google/google-doc';

  static create(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/create`, data).then(res => res.data);
  }

  static get(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/detail`).then(res => res.data);
  }
  static save(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/save`, data).then(res => res.data);
  }
  static closeEditor(fileId: string): Promise<any> {
    return this.axios.put(`${this.entity}/${fileId}/permission/close`).then(res => res.data);
  }
  static openEditor(fileId: string, options?: { type?: string; role?: string; email?: string }): Promise<any> {
    return this.axios.put(`${this.entity}/${fileId}/permission/open`, options || {}).then(res => res.data);
  }

  static openAnyoneView(fileId: string): Promise<any> {
    return this.openEditor(fileId, { type: 'anyone', role: 'reader' });
  }
  static saveFile(fileId: string , fileName: string, agreementId?: string, isMainFile: 'Y'|'N' = 'Y'): Promise<any> {
    return this.axios.post(`${this.entity}/${fileId}/create`, { fileName, agreementId, isMainFile }).then(res => res.data);
  }

  static getPdf(fileId: string): Promise<Blob> {
    console.log('getPdf called with fileId:', fileId);
    return this.axios.get(
      `${this.entity}/pdf`, { params: { fileId }, responseType: 'arraybuffer' }
    ).then(res => {
      console.log('getPdf response:', res.status, res.headers);
      const contentType = (res.headers && (res.headers['content-type'] || res.headers['Content-Type'])) || 'application/pdf';
      return new Blob([res.data], { type: contentType });
    }).catch(error => {
      console.error('getPdf error:', error);
      throw error;
    });
  }

  static getMedia(fileId: string): Promise<Blob & { fileName?: string }> {
    return this.axios.get(
      `${this.entity}/media`,
      { params: { fileId }, responseType: 'arraybuffer' }
    ).then(res => {
      const contentType = (res.headers && (res.headers['content-type'] || res.headers['Content-Type'])) || 'application/octet-stream';
      
      // Extract filename from Content-Disposition header
      let fileName: string | null = null;
      const contentDisposition = res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition']);
      console.log('getMedia: contentDisposition =', contentDisposition);
      
      if (contentDisposition) {
        // Try filename* (RFC 5987) first - better Unicode support
        const filenameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/);
        if (filenameStarMatch && filenameStarMatch[1]) {
          try {
            fileName = decodeURIComponent(filenameStarMatch[1]);
            console.log('getMedia: Extracted filename from filename*:', fileName);
          } catch (e) {
            console.warn('getMedia: Failed to decode filename*:', e);
          }
        }
        // Fallback to filename if filename* not found
        if (!fileName) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            fileName = filenameMatch[1].replace(/['"]/g, '');
            try {
              fileName = decodeURIComponent(fileName);
            } catch (e) {
              // If decode fails, use as is
            }
            console.log('getMedia: Extracted filename from filename:', fileName);
          }
        }
      }
      
      console.log('getMedia response:', res.headers);
      console.log('getMedia response data:', res.data);
      console.log('getMedia response contentType:', contentType);
      console.log('getMedia extracted fileName:', fileName);
      
      const blob = new Blob([res.data], { type: contentType }) as Blob & { fileName?: string };
      // Store filename in blob for later use
      if (fileName) {
        blob.fileName = fileName;
      }
      return blob;
    });
  }

  static getDocument(documentId: string): Promise<any> {
    return this.axios.get(`${this.entity}/documents/${documentId}`)
      .then(res => res.data);
  }

  static renameFile(fileId: string, fileName: string): Promise<any> {
    return this.axios.patch(`${this.entity}/${fileId}`, { fileName })
      .then(res => res.data);
  }
}